module.exports = __webpack_public_path__ + "media/images/icons/flags/NR-6b556fe998298de2cc5e65635aa19b05.svg";